import React, { PropTypes } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";

import SizeTable from "./SizeTable";
import NativeAd from "../Amazon/NativeAd";

import "./BrandPage.css";

class BrandPage extends React.Component {
  descriptionName() {
    const brand = this.props.brand;
    return "./" + brand.key.replace(/([-^].|^.)/g, function(x){ return x.toUpperCase(); }).replace(/-/g, "");
  }

  brandDescription() {
    try {
      const descriptionName = require( this.descriptionName() ).default;
      const Description = React.createFactory( descriptionName );
      return <Description />;
    } catch(e) {
      return "";
    }
  }

  render() {
    const { brand, type, gender } = this.props;
    const description = this.brandDescription();
    return(
      <div id="brand-page" style={{paddingBottom: "2em"}}>
        <Helmet title={"Fit My Kid: " + brand.name + " " + type +  " Size Chart"} />
        <h1>{brand.name}</h1>
        <h2>{type} Size Chart</h2>

        <div id="marketing-block">
          <p className="text-center alert alert-info">
            Ditch the spreadsheets and easily find sizes across ALL brands with <br/><a href="/welcome/" className="btn btn-primary">Fit My Kid</a>
          </p>
        </div>
        <NativeAd brand={brand}/>
        <SizeTable brand={brand} gender={gender} type={type}/>

        <div className="welcome-link-container">
          <a href="/welcome/" className="btn btn-primary btn-lg">Easily find sizes across ALL brands</a>
        </div>
        {description}
      </div>
    );
  }
}

BrandPage.propTypes = {
  brand: PropTypes.object.isRequired,
  gender: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    gender: state.gender
  };
}

export default connect(mapStateToProps)(BrandPage);



/** WEBPACK FOOTER **
 ** ./src/components/Brands/BrandPage.js
 **/